<div *ngIf="cake" class="request-form-view-container">
  <div class="row">
    <div *ngIf="hasImages"
         class="col-md-6 ps-0 pr-sm-max-0">
      <product-image-gallery
        [images]="cake.images"
        [alt]="cake?.bakery?.name + ' - ' + cake?.name">
      </product-image-gallery>
    </div>

    <div [class.col-md-6]="hasImages"
         [class.col-md-12]="!hasImages">
      <div class="pt-sm-max-3">
        <h1 class="cake-name">{{ cake.name }}</h1>

        <div class="bakery-info-line font-md mt-2 fw-bold"
             *ngIf="showBakeryName && cake.bakery">
          <span [translate]="'common.from'"></span>
          {{ cake.bakery.name }}
        </div>

        <div class="mt-3">
          <div class="about-product-title font-md fw-bold"
               [translate]="'cakeBuilder.productInfo.aboutProduct'">
            About the product
          </div>

          <ng-container *ngIf="cake.description">
            <div class="cake-info-description wysiwyg description font-md mt-2"
                 [innerHTML]="cake.description">
            </div>
          </ng-container>
        </div>

        <div class="mt-5">
          <button class="send-request-btn btn btn-pink"
                  [translate]="'requestFormProductView.sendARequest'"
                  (click)="handleOnSendRequest()">
            Send a request
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
